export default __webpack_public_path__ + "static/media/12.MonobagMillsLtd..a0080e1f.jpg";